import { Alert, Box, Button, Stack, Typography } from '@mui/material';
import { SchoolOutlined } from '@mui/icons-material';
import { Link as RouterLink } from 'react-router-dom';
import { useAppSelector } from '../../hooks/useAppStore';

/**
 * SIN EXAMEN, SIN AYUDA NI SOPORTE. (pedido del user, 30/09/2026)
 *
 * Desde el 1/10 el agente de Imperium que no aprobó el curso "Tutoriales del CRM" no tiene
 * Ayuda, ni tickets, ni chat con Soporte. Lo decide el backend (`bloqueoPorExamen.ts`) y
 * llega en `/auth/me` como `examenPendiente`: acá solo se esconde y se explica. El candado
 * de verdad está en el servidor.
 */
export const CURSO_TUTORIALES = '6a906af1b97c987da939e271';
export const LINK_CURSO_TUTORIALES = `/capacitaciones/${CURSO_TUTORIALES}`;
export const ROLES_DE_SOPORTE = ['booster_support', 'booster_admin'];

export const TEXTO_BLOQUEO =
  'Para usar la Ayuda, reportar a soporte o escribirle a Soporte tenés que aprobar el examen del curso '
  + '"Tutoriales del CRM". Se habilita apenas lo apruebes.';

export function useExamenPendiente(): boolean {
  return useAppSelector((s) => !!s.auth.user?.examenPendiente);
}

/** El aviso, con el botón al curso. `compacto` para dentro de un panel o del chat. */
export function AvisoExamenPendiente({ compacto = false }: { compacto?: boolean }) {
  const boton = (
    <Button component={RouterLink} to={LINK_CURSO_TUTORIALES} variant="contained" size="small"
      startIcon={<SchoolOutlined />} sx={{ whiteSpace: 'nowrap' }}>
      Ir al curso
    </Button>
  );
  if (compacto) {
    return <Alert severity="info" icon={<SchoolOutlined />} action={boton}>{TEXTO_BLOQUEO}</Alert>;
  }
  return (
    <Box sx={{ maxWidth: 560, mx: 'auto', mt: 8, px: 2, textAlign: 'center' }}>
      <Stack spacing={2} alignItems="center">
        <SchoolOutlined sx={{ fontSize: 48, color: 'primary.main' }} />
        <Typography variant="h6" fontWeight={700}>Primero, el curso</Typography>
        <Typography color="text.secondary">{TEXTO_BLOQUEO}</Typography>
        {boton}
      </Stack>
    </Box>
  );
}

/** Envuelve una página entera: si el examen está pendiente, muestra el aviso en su lugar. */
export function SoloConExamen({ children }: { children: React.ReactNode }) {
  return useExamenPendiente() ? <AvisoExamenPendiente /> : <>{children}</>;
}
